export default __webpack_public_path__ + "static/media/Frame.33e98a43.png";